import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoDosis/editTipoDosis`, method: 'POST', body: values, token: token})
}
